import React from 'react';
import { components } from 'react-select-v3';
import { StyledContainer, StyledJourneyId, StyledShipperOrderId, StyledNotFound } from './styled';

const t = {
  no_job: 'No associated job',
  not_found: 'Not found',
};

const Option = (props) => {
  const { data } = props;
  const {
    journeyId,
    shipperOrderId,
    journeyIdMatchesSearch,
    shipperOrderIdMatchesSearch,
    noJourney,
    notFound,
  } = data;

  const error = noJourney || notFound;

  return (
    <components.Option {...props}>
      {error && <StyledNotFound>{notFound ? t.not_found : t.no_job}</StyledNotFound>}
      {!error && (
        <StyledContainer>
          <StyledJourneyId bold={journeyIdMatchesSearch}>{journeyId}</StyledJourneyId>
          <StyledShipperOrderId bold={shipperOrderIdMatchesSearch}>
            {shipperOrderId}
          </StyledShipperOrderId>
        </StyledContainer>
      )}
    </components.Option>
  );
};

export default Option;
